
import { MainLayout } from '@/components/layout/MainLayout';
import { SidebarNavigation } from '@/components/navigation/SidebarNavigation';
import { SessionContent } from '@/components/session/SessionContent';
import { useStemSession } from '@/hooks/useStemSession';
import { Loader2 } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const StemSplitter = () => {
  const isMobile = useIsMobile();
  const {
    sessions,
    isLoadingSessions,
    createSession,
    updateSession,
    deleteSession,
    isProcessing,
    setIsProcessing,
    progress,
    setProgress,
    processingDuration,
    setProcessingDuration,
    processingError,
    setProcessingError,
    handleFileSelect,
    activeSession,
    setActiveSession,
    retryProcessing
  } = useStemSession();

  if (isLoadingSessions) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }

  const currentSession = sessions?.find(s => s.id === activeSession.id);

  const handleDeleteSession = async (sessionId: string) => {
    if (sessionId === activeSession.id) {
      setActiveSession({ id: null, type: 'stem' });
    }
    await deleteSession.mutateAsync({ id: sessionId });
  };

  return (
    <MainLayout>
      <SidebarNavigation
        sessions={sessions || []}
        acapellaSessions={[]}
        drumSessions={[]}
        activeSession={activeSession.id}
        onSessionSelect={(id) => setActiveSession({ id, type: 'stem' })}
        onSessionDelete={handleDeleteSession}
        showStemSplitter={true}
        showAcapella={false}
        showDrumRemover={false}
      />
      <main className={`flex-1 ${isMobile ? 'w-full' : ''}`} style={{ backgroundColor: '#000000' }}>
        <SessionContent
          session={currentSession}
          isProcessing={isProcessing}
          progress={progress}
          processingError={processingError}
          processingDuration={processingDuration}
          onRetry={(id) => {
            setProcessingError(null);
            retryProcessing(id);
          }}
          onDelete={(id) => deleteSession.mutateAsync({ id })}
          onFileSelect={(file) => handleFileSelect(file, 'stem')}
          sessionType="stem"
        />
      </main>
    </MainLayout>
  );
};

export default StemSplitter;
